define(
    'viewmodels/secured/help/guided/createLibraries',[
        "viewmodels/ViewModel",
        "plugins/router",
        "helper/textParser",
        "services/session",
        "i19n!i19n/strings",
    ],
    function (ViewModel, router, textParser, session, i19n) {

        var vm = new ViewModel({
            i19n: i19n,
            id: '3',
            descriptions: ko.observableArray([]),
            todos: ko.observableArray([]),
            tip: ko.observable('')
        });

        vm.activate = function () {
            //text | href | target

            if (vm.descriptions().length == 0) {
                vm.descriptions.push("The Library is the top level of document control in fileplan. Libraries typically manage documents for each major function in your business. ");
                vm.descriptions.push("Your fileplan instance contains some sample Libraries for you to experiment with. ");
                vm.descriptions.push("Creating your own Libraries will require a little time and planning to set-up. Find the resources to help you here. ");
            }
            if (vm.todos().length == 0) {
                vm.todos.push({ icon: 'fa-video-camera', isDone: false, html: textParser.toHtml('Watch the {Working with Libraries | http://www.fileplan.com/working-with-libraries-video | _blank} video.') });
                vm.todos.push({ icon: 'fa-video-camera', isDone: false, html: textParser.toHtml('Watch the {Working with Lists | http://www.fileplan.com/working-with-lists-video | _blank} video.') });
                vm.todos.push({ icon: 'fa-book', isDone: false, html: textParser.toHtml('Read the {What is a Library | http://help.fileplan.com/hc/en-us/articles/203335460-What-is-a-Library | _blank} article.') });
                vm.todos.push({ icon: 'fa-hand-pointer-o', isDone: false, html: textParser.toHtml('Use the Create button on the {Libraries page | #libraries | _blank} to create the Libraries you need in fileplan.') });
            }
            vm.tip(textParser.toHtml("Delete fileplan's sample Libraries once you no longer need them. Read {Emptying and Deleting Libraries | http://help.fileplan.com/hc/en-us/articles/203335470-Emptying-and-Deleting-Libraries | _blank} in the Knowledge Base to learn how."));
        };
        vm.attached = function () {
            $(".a-route").unbind("click");
            $(".a-route").bind("click", function (e) {
                router.navigate($(this).attr("href"));

                return false;
            });
        };

        return vm;
    }
);
